import React, { useEffect } from 'react';

import i18n from 'i18n';

import { SNACKBAR_ID } from './constants';

interface ITextCarouselProps {
  id: string;
  title: string;
  statuses: string[];
  translate?: boolean;
}

export const TextCarousel: React.FC<ITextCarouselProps> = ({ id, title, statuses, translate }) => {
  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      if (i >= statuses.length) {
        clearInterval(interval);
        return;
      }
      const ref = document.getElementById(SNACKBAR_ID + id);
      if (ref) {
        const snackbarContent = ref.querySelector<HTMLElement>('#snackbarContent');

        if (snackbarContent) {
          snackbarContent.innerText = `${
            translate
              ? i18n.t('proposal_content.file.snackbar.generating_file', {
                  proposal_title: title,
                })
              : `File ${title} is generating. Please wait.`
          } ${statuses[i]}`;
        }
      }

      i++;
    }, 3000);
  }, []);

  return (
    <>
      {translate ? i18n.t('proposal_content.file.snackbar.starting_download') : 'Starting download '} "{title}"…
    </>
  );
};
